export default "__VITE_ASSET__0cc2e8f1__"